import { Component, OnInit, AfterViewInit, HostListener, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DebugService } from '../../services/debug.service';
import { DataIoService } from '../../services/data-io.service';
import { TranslationService } from '../../services/translation.service';
import { MenuService } from '../../services/menu.service';
import { ConfigService } from '../../services/config.service';
import { environment } from '../../../environments/environment'
import { MenuNode } from '../../classes/MenuNode';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
    selector: 'app-simulator',
    templateUrl: './simulator.component.html',
    styleUrls: ['./simulator.component.scss']
})
export class SimulatorComponent implements OnInit,AfterViewInit {
	infoText: string;
    _debug:boolean=false;

    _upLoop:any;
    _downLoop:any;
    _loop_interval=100;
    _loop_offset=250;

    debug(msg:string):void{
        if(this._debug){
            console.log("SimulatorComponent: "+msg);
        }
    }

    getTranslator():TranslationService{
        return this.translator;
    }

    constructor(
        private router : Router,
        private route : ActivatedRoute,
        private debugService: DebugService, 
        private ioService: DataIoService,
        private menuService:MenuService,
        private translator:TranslationService,
        private deviceService: DeviceDetectorService,
        private ref: ChangeDetectorRef,
        private config:ConfigService) { 
        this.debug("Constructor.");
        this._debug = (!environment.production);
    }

    
    @ViewChild("simulatorWrap",{static:true}) simulatorWrap: ElementRef;
    get fontSize(){
        let bigWidth = 855;
        let elWidth = this.simulatorWrap.nativeElement.offsetWidth;
        //console.log("ElWidth:"+elWidth);
        this.ioService.setWindowWidth(elWidth);
        //42.5 bei 360 müsste 39.5 sein
        return 100.0*(elWidth/bigWidth)+"%";
    }
    onResize(event){
        this.ref.markForCheck();

        this.ioService.setWindowWidth(this.simulatorWrap.nativeElement.offsetWidth);
        this.ioService.inputs.resized();
    }
    getWidth(){
        var el = this.simulatorWrap.nativeElement;
        var divWidth = el.offsetWidth
    }
    get opacity(){
        return this.ioService.deviceInfo().getScale('brightness').getCurrentValue()*100;
    }
    ngOnInit() {
        this.ioService.onInfoTextAvailable().subscribe(
            (element)=>{
                this.showInfoTextFor(element);
            },
            (error)=>{
                this.debug("Error handling focused element: "+JSON.stringify(error));
            }

            );
    }


    ngAfterViewInit(){
        this.getWidth();
    }

    _caption : string = "";
    formatInfoText(str:string):string{
        if(str){
            return str.replace(/\n-/g,"\n\n-");
        }else{
            return '';
        }
    }
    removeVars(title:string):string{
        let matches= title.match(/{{[^t^r^:][^{^}]*?}}/g);
        if(matches != null && matches.length > 0){
            for(let match of matches){
                title = title.replace(match,'');
            }
        }
        return title;
    }
    extractInfoTitle(element){

        let rawTitle = element.title;
        // find elements like {{tr:string}}
        let matches= rawTitle.match(/{{tr[^{^}]*?}}/g);
        if(matches != null && matches.length > 0){
            rawTitle = matches[0];
        }
        if(rawTitle == '{{self.value}}'){
            rawTitle = element.defaultValue;
        }
        rawTitle = this.removeVars(rawTitle);
        rawTitle = rawTitle.replace('{{tr:','');
        rawTitle = rawTitle.replace('}}','');
        return rawTitle;
    }
    showInfoTextFor(element:MenuNode){

        let infoId = element.getInfoTextId();
        if(infoId != ""){
            this.infoText = this.formatInfoText(this.translator.getInfoText(infoId));

        }else{
            this.infoText = "";
        }

        this._caption = this.extractInfoTitle(element);
        /*
        if(['list','settingsvalue','control-showcase','menu-showcase','help','toast'].includes(element.getTemplate())){
            return;
        }
        if(element.getType() == "menuentry" && !element.hasChild() && infoId == ""){
            return;
        }
        if(element.isDescendantOf('zeitprogrammassistent')){
            return;
        }
        */
    }
    get caption():string{
        let caption = this.translator.tr(this._caption).replace(':','');
        caption = caption.replace('{{iconControl}} ','');
        caption = caption.replace('{{iconInformation}} ','');
        caption = caption.replace('{{iconConfigurationSettings}} ','');

        let matches = caption.match(/{{getzone\.[0-9]\.name*?/g);
        if(matches){
            matches = caption.match(/[0-9]/);
            if(matches){
                let id= parseInt(matches[0]);
                caption = this.translator.tr('ANCHOR_ZONE_X') + " " + id;
            }else{
                caption = '';
            }
        }

        if(matches){
            matches = caption.match(/[0-9]/);
            if(matches){
                let id= parseInt(matches[0]);
                caption = this.translator.tr('ANCHOR_ZONE_X') + " " + id;
            }else{
                caption = '';
            }
        }
        caption = caption.replace(/[0-9]\/[0-9]*/g,'');

        return caption;
    }
    
    goToSetup($event){
        $event.preventDefault();
        this.menuService.reset();
        this.router.navigate(['setup']);
    }


    buttonBlinking(btn){
        return this.menuService.buttonBlinking(btn);
    }


    buttonMuted(btn){

        return this.menuService.buttonMuted(btn)|| this.menuService.isDisabledByView(btn);
    }

    whiteQuestionMark():boolean{
        let nodeId = this.menuService.getCurrentNode().getIdentifier();
        switch(nodeId){
            case 'wizard_help':{
                return true;
            }
            default:{
                return false;
            }
        }
        return false;
    }
    whiteMenuButton() : boolean{
        let nodeId = this.menuService.getCurrentNode().getIdentifier();
        if(nodeId)
            switch(nodeId){
                case 'dashboard':
                case 'idle':
                case 'benutzerhandbuch':
                case 'benutzerhandbuch_plain':{
                    return false;
                }
                default:{
                    if(nodeId.startsWith('controlshowcase')){
                        return false;
                    }
                }
            }
            return true;
        }
        hasNotButton(btn){
            return (!!!this.hasButton(btn));
        }

        hasButton(btn){
            if(btn == "scrollbar"){

            }
            if(btn == 'question'){
                return this.menuService.helpAvailable() || this.menuService.buttonEnabled('question');
            }
            return this.menuService.buttonEnabled(btn);
        }


        questionClicked(){
            this.ioService.questionClicked();
        }
        backClicked(){
            if(!this.buttonMuted('back')){
                this.ioService.backClicked();
            }
        }

        confirmClicked(){
            if(!this.buttonMuted('confirm')){
                this.ioService.confirmClicked();
            }else{
                this.debug("Confirm muted.");
            }
        }

        menuClicked(){
            if(!this.buttonMuted('menu')){
                if(this.hasButton('menu')){
                    this.ioService.menuClicked();
                }
            }
        }


        menuUpClicked(){
            if(this.buttonMuted('up')){
                return;
            }
            this.debug("UpClicked");
            if(this.clickEnabled){
                this.ioService.upClicked();
            }
            
        }



        menuDownClicked(){
            if(this.buttonMuted('down')){
                return;
            }
            this.debug("DownClicked");
            if(this.clickEnabled){
                this.ioService.downClicked();
            }
            

        }


        onPan($event){
            
            this._downPressed=false;
            this._upPressed=false;
        }

        _panning = false;


        onPanStart($event){
            this._panning=true;
            this.ioService.panStart();
            this._downPressed=false;
            this._upPressed=false;
        }

        clickEnabled = true;
        disableClick(){
            this.clickEnabled = false;
        }
        enableClick(){
            this.clickEnabled = true;
        }
        onPanEnd($event){
            $event.preventDefault();
            setTimeout(()=>{
                this.enableClick();
            },50);
            this._panning = false;
            this.ioService.panEnd();
            this._downPressed=false;
            this._upPressed=false;
        }


        onPanMove($event){

        }


        onPanUp($event){
            $event.preventDefault();
            this.disableClick();
            this._downPressed = false;
            this._upPressed = false;
            
            if(this.buttonMuted('up')&&this.buttonMuted('slider')){
                return;
            }
            if(this._panning){
                this.ioService.panUp();
            }

        }


        pans=0;
        skips=6;


        onPanDown($event){
            this.disableClick();
            this._downPressed = false;
            
            this._upPressed = false;
            if(this.buttonMuted('down')&&this.buttonMuted('slider')){
                return;
            }
            
            //this.pans = (++this.pans % this.skips);
            if(this._panning){
                this.ioService.panDown();
            }

        }

        downPressed($event){
            $event.preventDefault();
            this._upPressed = false;
            this._downPressed = true;
            setTimeout(
                ()=>{
                    if(this._downPressed && !this._panning){
                        this._downLoop = setInterval(
                            ()=>{
                                if(!this._downPressed||this._panning){
                                    clearInterval(this._downLoop);
                                    return;
                                }else{

                                    this.menuDownClicked();
                                }
                            },
                            this._loop_interval);
                    }
                },
                this._loop_offset);
        }


        downReleased($event){
            this._downPressed = false;
            this._upPressed = false;
        }


        upPressed($event){
            $event.preventDefault();
            this._downPressed = false;
            this._upPressed = true;
            setTimeout(
                ()=>{
                    if(this._upPressed && !this._panning){
                        this._upLoop = setInterval(
                            ()=>{
                                if(!this._upPressed||    this._panning){
                                    clearInterval(this._upLoop);
                                    return;
                                }else{

                                    this.menuUpClicked();
                                }
                            },
                            this._loop_interval);
                    }
                },
                this._loop_offset);
        }


        upReleased($event){
            //console.log("Up released.");
            this._upPressed = false;
            this._downPressed = false;
        }
        _downPressed=false;
        _upPressed=false;
        
        @HostListener('window:keydown', ['$event'])
        keyEvent(ke: KeyboardEvent) {
            switch(ke.keyCode){
                case 70:{ // f
                    ke.stopPropagation();
                    this.menuService.goto('fachhandwerkerebene');
                    return false;
                }
                case 13:{ // 
                    this.confirmClicked();
                    ke.stopPropagation();
                    ke.stopImmediatePropagation();
                    return false;
                }
                case 37:{
                    this.backClicked();
                    ke.stopPropagation();
                    ke.stopImmediatePropagation();
                    return false;
                }
                case 38:{
                    this.menuUpClicked();
                    ke.stopPropagation();
                    ke.stopImmediatePropagation();
                    return false;
                }
                case 39:{
                    this.menuClicked();
                    ke.stopPropagation();
                    ke.stopImmediatePropagation();
                    return false;
                }
                case 40:{
                    this.menuDownClicked();
                    ke.stopPropagation();
                    ke.stopImmediatePropagation();
                    return false;
                }
            }
            console.log("Key Pressed: "+ke.keyCode);
            this.debug("Key Down: "+ke.keyCode);
        }



    }